<i ng-show="node.Expanded && node.HasChildren" ng-click="arrowToggle(node)" class="fa fa-angle-down"></i>
<i ng-show="!node.Expanded && node.HasChildren" ng-click="arrowToggle(node)" class="fa fa-angle-right"></i>
<i ng-show="!node.HasChildren"></i>
<span ng-if="treeType === 'ForSetTags'">
    <span ng-if="!node.IsStructureOnly">
        <span id="{{node.Id}}" class="is-static noselect" c-draggable ng-dblclick="onDoubleClick(node)" ng-class="{expanded: node.Expanded, hasNoChildren: !node.HasChildren}" ng-click="toggle(node)">
            {{localize(node.Name)}}
        </span>
    </span>
    <span ng-if="node.IsStructureOnly">
        <span class="is-static is-structure-only" ng-class="{expanded: node.Expanded, hasNoChildren: !node.HasChildren}" ng-click="toggle(node)">
            {{localize(node.Name)}}
        </span>
    </span>
</span>
<span ng-if="treeType === 'ForWorkflowList'">
    <a ui-sref="read.tag({tagId: node.Id})" ui-sref-active="active" ng-class="{expanded: node.Expanded, hasNoChildren: !node.HasChildren}" ng-click="toggle(node)">
        {{localize(node.Name)}}
    </a>
</span>
<span ng-if="treeType === 'ForLinkWorkflow'">
    <a id="{{node.Id}}" ui-sref-active="active" ng-class="{active: node.selected, expanded: node.Expanded, hasNoChildren: !node.HasChildren}" ng-click="toggle(node)">
        {{localize(node.Name)}}
    </a>
</span>
<span ng-if="treeType === 'ForTagList'">
    <a ng-class="{expanded: node.Expanded, hasNoChildren: !node.HasChildren}" ng-click="toggle(node)">
        {{localize(node.Name)}}
    </a>
</span>